import { createClient } from '@supabase/supabase-js'
const supaBaseURL =process.env.REACT_APP_SUPABASEURL
const supaBaseKey = process.env.REACT_APP_SUPABASE_KEY
export const supabase = createClient(supaBaseURL, supaBaseKey)
